/* ============================================================
   KRZ Shop — Progressive Enhancement JS
   No routing, no SPA, no content injection.
   All content rendered by Liquid SSR.
   ============================================================ */

(function () {
  'use strict';

  /* --------------------------------------------------------
     0. Helpers
     -------------------------------------------------------- */
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); };

  /* --------------------------------------------------------
     1. Scroll reveal (IntersectionObserver)
     -------------------------------------------------------- */
  function initScrollReveal() {
    var root = document.documentElement;
    var els = $$('.rv');
    if (!els.length) { root.classList.add('js-reveal'); return; }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || typeof IntersectionObserver === 'undefined') {
      els.forEach(function (el) { el.classList.add('vis'); });
      root.classList.add('js-reveal');
      return;
    }

    /* perf — aucune mesure synchrone (getBoundingClientRect forçait une mise en page complète) :
       le 1er retour de l'IntersectionObserver arrive après la mise en page du navigateur ;
       on révèle ce qui est déjà à l'écran, puis seulement on active le masquage des autres. */
    var first = true;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vis');
          observer.unobserve(entry.target);
        }
      });
      if (first) { first = false; root.classList.add('js-reveal'); }
    }, { threshold: 0, rootMargin: '0px 0px 20% 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }


  /* --------------------------------------------------------
     2. Nav scroll effect (merged into unified scroll handler)
     -------------------------------------------------------- */
  function initNavScroll() {
    /* Scroll logic moved to initUnifiedScroll */
  }

  /* --------------------------------------------------------
     3. Category bar dropdowns — keyboard support
     -------------------------------------------------------- */
  function initCatbarDropdowns() {
    var items = $$('.catbar .ni');
    if (!items.length) return;

    items.forEach(function (item) {
      var dropdown = item.querySelector('.nd');
      if (!dropdown) return;

      // Keyboard: Enter / Space opens, Escape closes
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          item.classList.toggle('open');
        } else if (e.key === 'Escape') {
          item.classList.remove('open');
        }
      });
    });

    // Click outside closes any open dropdown
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.catbar .ni')) {
        items.forEach(function (item) { item.classList.remove('open'); });
      }
    });
  }

  /* --------------------------------------------------------
     4. Mobile bottom sheet
     -------------------------------------------------------- */
  /* Collections : « Voir plus de licences » — révèle 24 cartes de plus */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.krz-more');
    if (!btn) return;
    var grid = document.getElementById(btn.getAttribute('data-more-grid'));
    if (!grid) return;
    var next = grid.querySelectorAll('[data-more-item][hidden]');
    for (var i = 0; i < next.length && i < 24; i++) next[i].removeAttribute('hidden');
    var left = next.length - Math.min(24, next.length);
    if (left <= 0) { btn.parentNode.remove(); } else { var s = btn.querySelector('span'); if (s) s.textContent = '(' + left + ')'; }
  });

  function initBottomSheet() {
    var sheet = $('#bottom-sheet');
    var overlay = $('#bs-overlay');
    var burger = $('#pill-burger');
    if (!sheet) return;
    var isOpen = false;

    function collapseAll(except) {
      $$('.bs-item[data-bs-key]', sheet).forEach(function (item) {
        if (item === except) return;
        item.classList.remove('open');
        item.setAttribute('aria-expanded', 'false');
        var sub = document.getElementById(item.getAttribute('data-bs-key'));
        if (sub) sub.classList.remove('open');
      });
    }

    function setOpen(open) {
      if (open === isOpen) return;
      isOpen = open;
      if (open) {
        var pb = document.getElementById('pill-bar');
        if (pb) sheet.style.setProperty('--mnav-top', Math.round(pb.getBoundingClientRect().bottom + 10) + 'px');
      }
      sheet.classList.toggle('open', open);
      if (overlay) overlay.classList.toggle('open', open);
      document.documentElement.classList.toggle('mnav-lock', open);
      if (burger) {
        burger.setAttribute('aria-expanded', String(open));
        burger.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
      }
      if (!open) {
        setTimeout(function () { if (!isOpen) { collapseAll(null); var b = sheet.querySelector('.bs-body'); if (b) b.scrollTop = 0; } }, 560);
      }
    }
    window.krzCloseMenu = function () { setOpen(false); };

    if (burger) burger.addEventListener('click', function () { setOpen(!isOpen); });

    // Glisser vers la gauche ferme le menu
    var tx = 0, ty = 0;
    sheet.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
    sheet.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0];
      if (t.clientX - tx < -70 && Math.abs(t.clientY - ty) < 50) setOpen(false);
    }, { passive: true });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-bs]')) { e.preventDefault(); setOpen(true); return; }
      if (e.target.closest('[data-close-bs]')) { e.preventDefault(); setOpen(false); return; }
      var trigger = e.target.closest('.bs-item[data-bs-key]');
      if (!trigger) return;
      var sub = document.getElementById(trigger.getAttribute('data-bs-key'));
      var willOpen = !trigger.classList.contains('open');
      collapseAll(trigger);
      trigger.classList.toggle('open', willOpen);
      trigger.setAttribute('aria-expanded', String(willOpen));
      if (sub) sub.classList.toggle('open', willOpen);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) { setOpen(false); if (burger) burger.focus(); }
    });

    var mq = window.matchMedia('(min-width:1100px)');
    var onMq = function (ev) { if (ev.matches) setOpen(false); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
    window.addEventListener('pageshow', function () { setOpen(false); });
  }

  /* --------------------------------------------------------
     5. FAQ accordions
     -------------------------------------------------------- */
  function initFaqAccordions() {
    function toggleFaq(e) {
      var q = e.target.closest('.faq-q');
      if (!q) return;

      /* Keyboard: only Enter or Space */
      if (e.type === 'keydown') {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
      }

      var item = q.closest('.faq-i');
      if (!item) return;

      /* Support both class conventions: .open (global) and .faq-i--open (product page) */
      var inProductFaq = !!item.closest('.pp-faq-section');
      var openClass = inProductFaq ? 'faq-i--open' : 'open';
      var isOpen = item.classList.contains(openClass);
      item.classList.toggle(openClass, !isOpen);
      q.setAttribute('aria-expanded', String(!isOpen));
    }

    document.addEventListener('click', toggleFaq);
    document.addEventListener('keydown', toggleFaq);
  }

  /* --------------------------------------------------------
     6. Product page tabs
     -------------------------------------------------------- */
  function initProductTabs() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tab-btn]');
      if (!btn) return;

      var tabId = btn.getAttribute('data-tab-btn');
      var container = btn.closest('.tabs, .t-tabs, [data-tabs]') || btn.parentElement.parentElement;
      if (!container) return;

      // Deactivate all sibling buttons
      $$('[data-tab-btn]', container).forEach(function (b) {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
      if (window.innerWidth < 768) btn.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });

      // Deactivate all tab contents, activate target
      $$('.t-content', container).forEach(function (panel) {
        panel.classList.remove('active');
      });

      var target = container.querySelector('.t-content[data-tab="' + tabId + '"]') ||
                   container.querySelector('#' + tabId);
      if (target) {
        target.classList.add('active');
      }
    });
  }

  /* --------------------------------------------------------
     7. Cart AJAX (progressive enhancement)
     -------------------------------------------------------- */
  function initCartAjax() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form');
      if (!form || !form.querySelector('.btn-cart')) return;

      // Only enhance forms that post to /cart/add
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      e.preventDefault();

      var btn = form.querySelector('.btn-cart');
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = '...';

      // On product page, redirect after add (keep existing behaviour)
      var isProductPage = document.body.getAttribute('data-page') === 'product';

      // Find product image for fly animation
      var imgEl = _findProductImage(form);

      // Fire fly animation (non-blocking)
      if (imgEl && !isProductPage) _flyToCart(imgEl);

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error');
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        _syncAllCartUI(cart, !isProductPage);
        if (isProductPage) {
          window.location.href = '/cart';
        } else {
          btn.textContent = originalText;
          btn.disabled = false;
        }
      })
      .catch(function () {
        form.submit();
      });
    });
  }

  /* --------------------------------------------------------
     7b. Buy Now — direct checkout
     -------------------------------------------------------- */
  function initBuyNow() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.btn-now');
      if (!btn) return;
      var variantId = btn.getAttribute('data-variant');
      if (!variantId) return;
      var qty = 1;
      var qtyInput = document.querySelector('#pp-qty');
      if (qtyInput) qty = parseInt(qtyInput.value, 10) || 1;
      window.location.href = '/cart/' + variantId + ':' + qty;
    });
  }

  /* --------------------------------------------------------
     8. Toast notifications
     -------------------------------------------------------- */
  function showToast(msg) {
    var toast = $('#toast');
    if (!toast) return;

    toast.textContent = msg;
    toast.classList.add('show');

    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.classList.remove('show');
    }, 3000);
  }

  // Expose globally for Liquid inline calls if needed
  window.showToast = showToast;

  /* --------------------------------------------------------
     9. Quantity controls
     -------------------------------------------------------- */
  function initQuantityControls() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.qty-ctl [data-step]');
      if (!btn) return;

      var wrapper = btn.closest('.qty-ctl');
      if (!wrapper) return;

      var input = wrapper.querySelector('input');
      if (!input) return;

      var step = parseInt(btn.getAttribute('data-step'), 10) || 0;
      var current = parseInt(input.value, 10) || 1;
      var next = current + step;

      // Clamp between 1 and 99
      next = Math.max(1, Math.min(99, next));
      input.value = next;

      // Trigger change event for any listeners
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* --------------------------------------------------------
     10. Category panel (mobile ≤ 1024px)
     -------------------------------------------------------- */
  function initCatPanel() {
    var panel = $('#catpanel');
    if (!panel) return;

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-toggle-catpanel]');
      if (!trigger) return;

      if (window.innerWidth > 1024) return;

      e.preventDefault();
      panel.classList.toggle('open');
      trigger.setAttribute('aria-expanded', String(panel.classList.contains('open')));
    });

    // Close when resized above breakpoint
    window.addEventListener('resize', function () {
      if (window.innerWidth > 1024 && panel.classList.contains('open')) {
        panel.classList.remove('open');
      }
    }, { passive: true });
  }

  /* --------------------------------------------------------
     11. Pill header — scroll effect
     -------------------------------------------------------- */
  function initPillScroll() {
    var bar = $('#pill-bar');
    var hdr = $('#pill-hdr');
    if (!bar) return;
    /* Scroll logic moved to initUnifiedScroll */

    // Mouse spotlight effect — rAF-throttled
    var spotTicking = false;
    bar.addEventListener('mousemove', function (e) {
      if (spotTicking) return;
      spotTicking = true;
      requestAnimationFrame(function () {
        var rect = bar.getBoundingClientRect();
        bar.style.setProperty('--mouse-x', (e.clientX - rect.left) + 'px');
        bar.style.setProperty('--mouse-y', (e.clientY - rect.top) + 'px');
        spotTicking = false;
      });
    }, { passive: true });
    bar.addEventListener('mouseenter', function (e) {
      var rect = bar.getBoundingClientRect();
      bar.style.setProperty('--mouse-x', (e.clientX - rect.left) + 'px');
      bar.style.setProperty('--spotlight-opacity', '1');
    });
    bar.addEventListener('mouseleave', function () {
      bar.style.setProperty('--spotlight-opacity', '0');
    });
  }

  /* --------------------------------------------------------
     12. Mega-menu — hover/click/keyboard
     -------------------------------------------------------- */
  function initMegaMenu() {
    var triggers = $$('[data-mega-trigger]');
    var panels = $$('[data-mega-panel]');
    if (!triggers.length) return;

    var openTimer = null;
    var closeTimer = null;
    var currentMenu = null;

    function openMenu(key) {
      clearTimeout(closeTimer);
      closeTimer = null;

      // Close previous
      if (currentMenu && currentMenu !== key) {
        var prevPanel = $('[data-mega-panel="' + currentMenu + '"]');
        var prevItem = $('[data-mega-trigger="' + currentMenu + '"]');
        if (prevPanel) prevPanel.classList.remove('open');
        if (prevItem) {
          prevItem.closest('.pill-nav-item').classList.remove('active');
          prevItem.setAttribute('aria-expanded', 'false');
        }
      }

      var panel = $('[data-mega-panel="' + key + '"]');
      var trigger = $('[data-mega-trigger="' + key + '"]');
      if (panel) panel.classList.add('open');
      if (trigger) {
        trigger.closest('.pill-nav-item').classList.add('active');
        trigger.setAttribute('aria-expanded', 'true');
      }
      currentMenu = key;
    }

    function closeMenu(key) {
      var panel = $('[data-mega-panel="' + key + '"]');
      var trigger = $('[data-mega-trigger="' + key + '"]');
      if (panel) panel.classList.remove('open');
      if (trigger) {
        trigger.closest('.pill-nav-item').classList.remove('active');
        trigger.setAttribute('aria-expanded', 'false');
      }
      if (currentMenu === key) currentMenu = null;
    }

    function closeAll() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      panels.forEach(function (p) { p.classList.remove('open'); });
      triggers.forEach(function (t) {
        t.closest('.pill-nav-item').classList.remove('active');
        t.setAttribute('aria-expanded', 'false');
      });
      currentMenu = null;
    }

    // Hover triggers
    triggers.forEach(function (trigger) {
      var key = trigger.getAttribute('data-mega-trigger');

      trigger.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () { openMenu(key); }, 80);
      });

      trigger.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { closeMenu(key); }, 150);
      });

      // Click toggle
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (currentMenu === key) {
          closeAll();
        } else {
          openMenu(key);
        }
      });

      // Keyboard
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (currentMenu === key) closeAll();
          else openMenu(key);
        } else if (e.key === 'Escape') {
          closeAll();
          trigger.focus();
        } else if (e.key === 'ArrowDown' && currentMenu === key) {
          e.preventDefault();
          var panel = $('[data-mega-panel="' + key + '"]');
          if (panel) {
            var firstLink = panel.querySelector('a, button');
            if (firstLink) firstLink.focus();
          }
        }
      });
    });

    // Panel hover keeps menu open
    panels.forEach(function (panel) {
      panel.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
      });
      panel.addEventListener('mouseleave', function () {
        var key = panel.getAttribute('data-mega-panel');
        closeTimer = setTimeout(function () { closeMenu(key); }, 150);
      });

      // Arrow keys inside panel
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          var key = panel.getAttribute('data-mega-panel');
          closeMenu(key);
          var trigger = $('[data-mega-trigger="' + key + '"]');
          if (trigger) trigger.focus();
        }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          var focusable = Array.from(panel.querySelectorAll('a, button'));
          var idx = focusable.indexOf(document.activeElement);
          if (e.key === 'ArrowDown') idx = (idx + 1) % focusable.length;
          else idx = (idx - 1 + focusable.length) % focusable.length;
          focusable[idx].focus();
        }
      });
    });

    // Click outside closes
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.pill-nav-links') && !e.target.closest('.mega-panels')) {
        closeAll();
      }
    });

    // Office PC/Mac tabs
    var officeTabs = $$('[data-office-tab]');
    officeTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-office-tab');
        $$('[data-office-tab]').forEach(function (t) { t.classList.remove('active'); });
        $$('[data-office-content]').forEach(function (c) { c.classList.remove('active'); });
        tab.classList.add('active');
        var content = $('[data-office-content="' + target + '"]');
        if (content) content.classList.add('active');
      });
    });
  }

  /* --------------------------------------------------------
     13. Search pill — expand/collapse, predictive, keyboard
     -------------------------------------------------------- */
  function initSearchPill() {
    var form = $('#pill-search-form');
    var input = $('#pill-search-input');
    var toggle = $('#pill-search-toggle');
    var expand = $('#pill-search-expand');
    var closeBtn = $('#pill-search-close');
    var clearBtn = $('#pill-search-clear');
    var kbdBadge = $('#pill-search-kbd');
    var results = $('#pill-search-results');
    var loading = $('#psr-loading');
    var content = $('#psr-content');
    var navLinks = $('#pill-nav-links');

    if (!form || !input) return;

    var isOpen = false;
    var debounceTimer = null;
    var activeIndex = -1;
    var lastQuery = '';

    var pillBar = $('#pill-bar');

    function openSearch() {
      if (isOpen) return;
      isOpen = true;
      form.classList.remove('closed');
      form.classList.add('open');
      if (pillBar) pillBar.classList.add('search-active');
      input.tabIndex = 0;
      input.focus();
      if (closeBtn) closeBtn.style.display = '';
      if (kbdBadge) kbdBadge.style.display = '';
      if (navLinks) navLinks.classList.add('search-fade');
    }

    function closeSearch() {
      if (!isOpen) return;
      isOpen = false;
      form.classList.remove('open');
      form.classList.add('closed');
      if (pillBar) pillBar.classList.remove('search-active');
      input.tabIndex = -1;
      input.value = '';
      lastQuery = '';
      activeIndex = -1;
      if (closeBtn) closeBtn.style.display = 'none';
      if (kbdBadge) kbdBadge.style.display = 'none';
      if (clearBtn) clearBtn.style.display = 'none';
      if (results) results.style.display = 'none';
      if (navLinks) navLinks.classList.remove('search-fade');
    }

    // Initialize as closed
    form.classList.add('closed');

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!isOpen) openSearch();
    });

    if (closeBtn) closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      closeSearch();
    });

    if (clearBtn) clearBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      input.value = '';
      lastQuery = '';
      if (clearBtn) clearBtn.style.display = 'none';
      if (kbdBadge) kbdBadge.style.display = '';
      if (results) results.style.display = 'none';
      input.focus();
    });

    // Ctrl+K / Cmd+K shortcut
    document.addEventListener('keydown', function (e) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        if (isOpen) closeSearch();
        else openSearch();
      }
      if (e.key === 'Escape' && isOpen) {
        closeSearch();
      }
    });

    // Click outside
    document.addEventListener('click', function (e) {
      if (isOpen && !e.target.closest('.pill-search-wrap')) {
        closeSearch();
      }
    });

    // Input handling
    input.addEventListener('input', function () {
      var q = input.value.trim();

      // Show/hide clear vs ESC badge
      if (q.length > 0) {
        if (clearBtn) clearBtn.style.display = '';
        if (kbdBadge) kbdBadge.style.display = 'none';
      } else {
        if (clearBtn) clearBtn.style.display = 'none';
        if (kbdBadge) kbdBadge.style.display = '';
        if (results) results.style.display = 'none';
        return;
      }

      if (q.length < 2) return;

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        if (q === lastQuery) return;
        lastQuery = q;
        fetchPredictive(q);
      }, 200);
    });

    function fetchPredictive(q) {
      if (loading) { loading.style.display = ''; }
      if (content) { content.innerHTML = ''; }
      if (results) { results.style.display = ''; }
      activeIndex = -1;

      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,article&resources[limit]=5')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (loading) loading.style.display = 'none';
          renderResults(data, q);
        })
        .catch(function () {
          if (loading) loading.style.display = 'none';
          renderEmpty();
        });
    }

    function renderResults(data, q) {
      if (!content) return;
      var html = '';
      var res = data.resources && data.resources.results;
      if (!res) { renderEmpty(); return; }

      var products = res.products || [];
      var collections = res.collections || [];
      var hasResults = products.length > 0 || collections.length > 0;

      if (!hasResults) { renderEmpty(); return; }

      if (products.length > 0) {
        html += '<div class="psr-heading">Produits</div>';
        products.forEach(function (p) {
          var img = p.image ? '<img src="' + p.image.replace(/\.([^.]+)$/, '_small.$1') + '" alt="" class="psr-item-img" width="40" height="40" loading="lazy">' : '<div class="psr-item-img"></div>';
          var price = p.price ? (parseFloat(p.price) / 100).toFixed(2).replace('.', ',') + ' &euro;' : '';
          html += '<a href="' + p.url + '" class="psr-item" data-psr-idx>' +
            img +
            '<div class="psr-item-info"><div class="psr-item-title">' + escHtml(p.title) + '</div>' +
            (price ? '<div class="psr-item-price">' + price + '</div>' : '') +
            '</div></a>';
        });
      }

      if (collections.length > 0) {
        html += '<div class="psr-sep"></div><div class="psr-heading">Collections</div><div class="psr-collections">';
        collections.forEach(function (c) {
          html += '<a href="' + c.url + '" class="psr-coll-pill" data-psr-idx>' + escHtml(c.title) + '</a>';
        });
        html += '</div>';
      }

      html += '<div class="psr-sep"></div>';
      html += '<a href="/search?q=' + encodeURIComponent(q) + '" class="psr-viewall" data-psr-idx>Voir tous les r&eacute;sultats &rarr;</a>';

      content.innerHTML = html;
    }

    function renderEmpty() {
      if (!content) return;
      content.innerHTML =
        '<div class="psr-empty">' +
        '<div class="psr-empty-msg">Aucune licence trouv&eacute;e</div>' +
        '<div class="psr-suggestions">' +
        '<a href="/collections/microsoft-windows-1">Windows</a>' +
        '<a href="/collections/microsoft-office">Office</a>' +
        '<a href="/collections/pack-office-windows">Packs</a>' +
        '</div></div>';
    }

    function escHtml(s) {
      var d = document.createElement('div');
      d.textContent = s;
      return d.innerHTML;
    }

    // Keyboard navigation in results
    input.addEventListener('keydown', function (e) {
      if (!results || results.style.display === 'none') return;
      var items = Array.from(results.querySelectorAll('[data-psr-idx]'));
      if (!items.length) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIndex = Math.min(activeIndex + 1, items.length - 1);
        updateActive(items);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, -1);
        updateActive(items);
      } else if (e.key === 'Enter' && activeIndex >= 0) {
        e.preventDefault();
        items[activeIndex].click();
      }
    });

    function updateActive(items) {
      items.forEach(function (it, i) {
        it.classList.toggle('psr-active', i === activeIndex);
      });
    }
  }

  /* --------------------------------------------------------
     14. Dock effect — mouse proximity scaling
     -------------------------------------------------------- */
  function initDockEffect() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.innerWidth < 1100) return;

    var links = $('#pill-nav-links');
    if (!links) return;
    var items = $$('.pill-nav-item', links);
    if (items.length < 2) return;

    var dockTicking = false;
    links.addEventListener('mousemove', function (e) {
      if (dockTicking) return;
      dockTicking = true;
      requestAnimationFrame(function () {
        var mouseX = e.clientX;
        // 1) lectures d'abord (aucune écriture entre deux lectures)
        var centers = items.map(function (item) {
          var rect = item.getBoundingClientRect();
          return rect.left + rect.width / 2;
        });
        // 2) calcul des états
        var state = items.map(function () { return 0; });
        centers.forEach(function (c, i) {
          if (Math.abs(mouseX - c) < 30) {
            state[i] = 1;
            if (i > 0 && state[i - 1] === 0) state[i - 1] = 2;
            if (i < items.length - 1) state[i + 1] = 2;
          }
        });
        // 3) écritures ensuite
        items.forEach(function (item, i) {
          item.classList.toggle('dock-scale-1', state[i] === 1);
          item.classList.toggle('dock-scale-2', state[i] === 2);
        });
        dockTicking = false;
      });
    }, { passive: true });

    links.addEventListener('mouseleave', function () {
      items.forEach(function (item) {
        item.classList.remove('dock-scale-1', 'dock-scale-2');
      });
    });
  }

  /* --------------------------------------------------------
     15b. Hero flip cards
     -------------------------------------------------------- */
  function initHeroFlip() {
    var cards = $$('[data-hero-flip]');
    if (!cards.length) return;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var isTouch = 'ontouchstart' in window;

    if (reducedMotion) {
      cards.forEach(function(c) { c.classList.add('flipped'); });
      return;
    }

    if (isTouch) {
      // Mobile: IntersectionObserver — flip once when 60% visible
      var flipped = false;
      var obs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && !flipped) {
            flipped = true;
            cards[0].classList.add('flipped');
            if (cards[1]) setTimeout(function() { cards[1].classList.add('flipped'); }, 150);
            obs.disconnect();
          }
        });
      }, { threshold: 0.6 });
      obs.observe(cards[0].parentElement || cards[0]);
    } else {
      // Desktop: hover only — mouseenter verso, mouseleave recto
      cards.forEach(function(card) {
        card.addEventListener('mouseenter', function() { card.classList.add('flipped'); });
        card.addEventListener('mouseleave', function() { card.classList.remove('flipped'); });
      });
    }
  }

  /* --------------------------------------------------------
     16. Licence cards — tilt + key reveal
     -------------------------------------------------------- */
  function initLicenceCards() {
    var isTouch = 'ontouchstart' in window;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var REVEAL_TEXT = 'Livr\u00e9e\u00a0par\u00a0e-mail';
    var MASK = '\u2022\u2022\u2022\u2022\u2022-\u2022\u2022\u2022\u2022\u2022-\u2022\u2022\u2022\u2022\u2022-\u2022\u2022\u2022\u2022\u2022-\u2022\u2022\u2022\u2022\u2022';

    // Key reveal animation
    $$('[data-lc-key]').forEach(function (el) {
      var timer = null;
      var parent = el.closest('[data-lc]');
      if (!parent) return;

      parent.addEventListener('mouseenter', function () {
        if (isTouch || reducedMotion) return;
        clearTimeout(timer);
        animateKey(el, REVEAL_TEXT);
      });
      parent.addEventListener('mouseleave', function () {
        if (isTouch || reducedMotion) return;
        clearTimeout(timer);
        timer = setTimeout(function () { el.textContent = MASK; }, 80);
      });
    });

    function animateKey(el, target) {
      var padded = target;
      while (padded.length < MASK.length) padded += ' ';
      padded = padded.substring(0, MASK.length);
      el.textContent = '';
      for (var i = 0; i < padded.length; i++) {
        var span = document.createElement('span');
        span.className = 'lc-char';
        span.style.whiteSpace = 'pre';
        span.textContent = MASK[i] || ' ';
        el.appendChild(span);
      }
      var chars = Array.from(el.children);
      chars.forEach(function (ch, i) {
        setTimeout(function () {
          ch.classList.add('lc-flip');
          setTimeout(function () {
            ch.textContent = padded[i];
            ch.classList.remove('lc-flip');
          }, 80);
        }, i * 22);
      });
    }

    // Tilt effect
    if (isTouch || reducedMotion) return;
    $$('.lc-tilt').forEach(function (card) {
      var body = card.querySelector('.lc-body');
      if (!body) return;

      var tiltRaf = 0, lastX = 0, lastY = 0;
      card.addEventListener('mousemove', function (e) {
        lastX = e.clientX; lastY = e.clientY;
        if (tiltRaf) return;
        tiltRaf = requestAnimationFrame(function () {
          tiltRaf = 0;
          var r = body.getBoundingClientRect();
          var x = lastX - r.left;
          var y = lastY - r.top;
          var cx = r.width / 2;
          var cy = r.height / 2;
          var rotY = ((x - cx) / cx) * 8;
          var rotX = ((cy - y) / cy) * 8;
          body.style.transform = 'perspective(900px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg)';
          body.style.setProperty('--lc-mx', ((x / r.width) * 100) + '%');
          body.style.setProperty('--lc-my', ((y / r.height) * 100) + '%');
        });
      }, { passive: true });

      card.addEventListener('mouseleave', function () {
        if (tiltRaf) { cancelAnimationFrame(tiltRaf); tiltRaf = 0; }
        body.style.transform = '';
      });
    });
  }

  /* --------------------------------------------------------
     17. Cart page — AJAX quantity + remove
     -------------------------------------------------------- */
  function initCartPage() {
    var container = $('#cart-items');
    if (!container) return;

    function updateCart(key, quantity) {
      var row = container.querySelector('[data-key="' + key + '"]');
      if (row) row.classList.add('cart-updating');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error');
        return res.json();
      })
      .then(function (cart) {
        // Sync all floating UI (pill, badges, mini-cart)
        _syncAllCartUI(cart);

        // Update header cart badge (pill nav)
        var headerBadge = $('.cart-n');
        if (headerBadge) {
          headerBadge.textContent = cart.item_count > 0 ? cart.item_count : '';
        }

        if (cart.item_count === 0) {
          // Reload to show empty state
          window.location.reload();
          return;
        }

        // Update totals
        var totalFormatted = (cart.total_price / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
        var subtotalEl = $('#cart-subtotal');
        var totalEl = $('#cart-total');
        if (subtotalEl) subtotalEl.textContent = totalFormatted;
        if (totalEl) totalEl.textContent = totalFormatted;

        if (quantity === 0 && row) {
          // Remove the row with animation
          row.style.transition = 'opacity .25s ease, transform .25s ease';
          row.style.opacity = '0';
          row.style.transform = 'translateX(-20px)';
          setTimeout(function () { row.remove(); }, 260);
        } else if (row) {
          // Update quantity display
          var qtyVal = row.querySelector('[data-qty-val]');
          var lineItem = null;
          // Find this item in the updated cart
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].key === key) {
              lineItem = cart.items[i];
              break;
            }
          }
          if (lineItem && qtyVal) {
            qtyVal.textContent = lineItem.quantity;
          }
          // Update line price
          if (lineItem) {
            var priceEl = row.querySelector('.cart-item-price');
            if (priceEl) {
              priceEl.textContent = (lineItem.final_line_price / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
            }
          }
          row.classList.remove('cart-updating');
        }
      })
      .catch(function () {
        if (row) row.classList.remove('cart-updating');
        window.location.reload();
      });
    }

    // Quantity buttons
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-qty]');
      if (!btn) return;

      var key = btn.getAttribute('data-key');
      var step = parseInt(btn.getAttribute('data-cart-qty'), 10);
      var row = btn.closest('.cart-item');
      var qtyVal = row ? row.querySelector('[data-qty-val]') : null;
      var current = qtyVal ? parseInt(qtyVal.textContent, 10) : 1;
      var next = Math.max(0, current + step);

      if (next === 0) {
        updateCart(key, 0);
      } else {
        updateCart(key, next);
      }
    });

    // Remove buttons
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-rm]');
      if (!btn) return;

      var key = btn.getAttribute('data-key');
      updateCart(key, 0);
    });
  }

  /* --------------------------------------------------------
     18. Fly-to-cart animation + floating pill + mini-cart
     -------------------------------------------------------- */

  /* -- Helpers -- */
  function _findProductImage(origin) {
    var card = origin.closest('.pc') || origin.closest('.mega-feat-card') || origin.closest('.pp-left') || origin.closest('[data-product]') || origin.closest('form');
    if (!card) return null;
    return card.querySelector('.pc-img img, .mega-feat-img img, .pp-img img, .pp-img-svg, img');
  }

  function _formatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
  }

  /* -- Fly animation -- */
  function _flyToCart(imgEl) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var rect = imgEl.getBoundingClientRect();
    var clone = document.createElement('img');
    var inner = imgEl.querySelector('img');
    clone.src = imgEl.src || (inner ? inner.src : '') || '';
    if (!clone.src) return;
    clone.className = 'fly-clone';
    clone.style.width = Math.min(rect.width, 120) + 'px';
    clone.style.height = Math.min(rect.height, 120) + 'px';
    clone.style.left = '0px';
    clone.style.top = '0px';
    document.body.appendChild(clone);

    var startX = rect.left + rect.width / 2 - Math.min(rect.width, 120) / 2;
    var startY = rect.top + rect.height / 2 - Math.min(rect.height, 120) / 2;

    // Target: cart icon on desktop, mob-badge on mobile
    var target;
    var isDesktop = window.innerWidth >= 1100;
    if (isDesktop) {
      target = $('#pill-cart-icon') || $('.pill-cart');
    } else {
      target = $('#pill-cart-icon') || $('.pill-cart');
    }

    var endX = startX, endY = startY;
    if (target) {
      var tRect = target.getBoundingClientRect();
      endX = tRect.left + tRect.width / 2 - Math.min(rect.width, 120) * 0.15;
      endY = tRect.top + tRect.height / 2 - Math.min(rect.height, 120) * 0.15;
    }

    var midX = (startX + endX) / 2;
    var midY = Math.min(startY, endY) - 80;

    var anim = clone.animate([
      { transform: 'translate(' + startX + 'px,' + startY + 'px) scale(1)', opacity: 1 },
      { transform: 'translate(' + midX + 'px,' + midY + 'px) scale(0.6)', opacity: 1, offset: 0.4 },
      { transform: 'translate(' + endX + 'px,' + endY + 'px) scale(0.3)', opacity: 0 }
    ], { duration: 700, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' });

    anim.onfinish = function () { clone.remove(); };
    setTimeout(function () { clone.remove(); }, 1200);
  }

  /* -- Sync all cart UI elements -- */
  var _previewAutoTimer = null;
  function _syncAllCartUI(cart, openPreview) {
    var count = cart.item_count;

    // Mobile badge
    if (window._updateMobBadge) window._updateMobBadge(count);

    // Header badge + bounce
    var headerBadge = $('.pill-cart-n');
    if (headerBadge) {
      headerBadge.textContent = count > 0 ? count : '';
      headerBadge.classList.remove('pop');
      void headerBadge.offsetWidth;
      headerBadge.classList.add('pop');
    }

    // Mobile badge bounce
    var mobBadge = $('#mob-badge');
    if (mobBadge && count > 0 && window.innerWidth < 1100) {
      mobBadge.classList.remove('mob-badge--bounce');
      void mobBadge.offsetWidth;
      mobBadge.classList.add('mob-badge--bounce');
    }

    // Mini-cart contents
    _renderMiniCart(cart);

    // Show/hide empty state
    var emptyEl = $('#cart-preview-empty');
    var itemsEl = $('#mini-cart-items');
    var footEl = $('.mini-cart-foot');
    var infoEl = $('.mini-cart-info');
    if (emptyEl) emptyEl.style.display = count === 0 ? '' : 'none';
    if (itemsEl) itemsEl.style.display = count > 0 ? '' : 'none';
    if (footEl) footEl.style.display = count > 0 ? '' : 'none';
    if (infoEl) infoEl.style.display = count > 0 ? '' : 'none';

    // Auto-open preview after add (3s, stays if hovered)
    if (openPreview && window.innerWidth >= 1100 && !window.location.pathname.match(/\/cart/)) {
      clearTimeout(_previewAutoTimer);
      _openPreview();
      _previewAutoTimer = setTimeout(function () {
        var p = $('#cart-preview');
        if (p && !p.matches(':hover')) _closePreview();
      }, 3000);
    }
  }

  /* -- Render mini-cart items -- */
  function _renderMiniCart(cart) {
    var itemsWrap = $('#mini-cart-items');
    var totalEl = $('#mini-cart-total');
    var countEl = $('[data-mini-cart-count]');

    if (countEl) countEl.textContent = cart.item_count;
    if (totalEl) totalEl.textContent = _formatPrice(cart.total_price);

    if (!itemsWrap) return;
    var html = '';
    cart.items.forEach(function (item) {
      var img = item.image ? item.image.replace(/(\.[^.]+)$/, '_small$1') : '';
      html += '<div class="mc-item" data-mc-key="' + item.key + '">' +
        (img ? '<img class="mc-item-img" src="' + img + '" alt="" width="44" height="44">' : '') +
        '<div class="mc-item-info"><div class="mc-item-name">' + item.product_title + '</div>' +
        '<div class="mc-item-price">' + _formatPrice(item.final_line_price) + '</div></div>' +
        '<div class="mc-item-qty">' +
        '<button data-mc-qty="-1" data-mc-key="' + item.key + '" aria-label="Moins">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button data-mc-qty="1" data-mc-key="' + item.key + '" aria-label="Plus">+</button>' +
        '</div>' +
        '<button class="mc-item-rm" data-mc-rm="' + item.key + '" aria-label="Supprimer">×</button>' +
        '</div>';
    });
    itemsWrap.innerHTML = html;
  }

  /* -- Mini-cart quantity / remove -- */
  function _miniCartChange(key, delta) {
    var row = $('[data-mc-key="' + key + '"].mc-item');
    var qtySpan = row ? row.querySelector('.mc-item-qty span') : null;
    var current = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
    var next = Math.max(0, current + delta);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: next })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) { _syncAllCartUI(cart); })
    .catch(function () {});
  }

  /* -- Open/close cart preview -- */
  function _openPreview() {
    var p = $('#cart-preview'); if (!p) return;
    p.style.display = 'flex';
    requestAnimationFrame(function(){ p.classList.add('open'); });
  }
  function _closePreview() {
    var p = $('#cart-preview'); if (!p) return;
    p.classList.remove('open');
    setTimeout(function(){ if (!p.classList.contains('open')) p.style.display = 'none'; }, 250);
  }

  /* -- Init fly cart + cart preview on hover -- */
  function initFlyCart() {
    var wrap = $('#pill-cart-wrap');
    var preview = $('#cart-preview');
    var isCartPage = window.location.pathname === '/cart';
    var hoverOpen = null, hoverClose = null;

    // Initial cart fetch
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { _syncAllCartUI(cart); _renderMiniCart(cart); })
      .catch(function () {});

    // Desktop hover: open/close with delay
    if (wrap && preview && window.innerWidth >= 1100 && !isCartPage) {
      wrap.addEventListener('mouseenter', function () {
        clearTimeout(hoverClose);
        hoverOpen = setTimeout(_openPreview, 150);
      });
      wrap.addEventListener('mouseleave', function () {
        clearTimeout(hoverOpen);
        hoverClose = setTimeout(_closePreview, 250);
      });
      preview.addEventListener('mouseenter', function () { clearTimeout(hoverClose); });
      preview.addEventListener('mouseleave', function () { hoverClose = setTimeout(_closePreview, 250); });

      // Focus opens preview (keyboard)
      var cartIcon = $('#pill-cart-icon');
      if (cartIcon) {
        cartIcon.addEventListener('focus', function () { clearTimeout(hoverClose); _openPreview(); });
      }
    }

    // Escape closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && preview && preview.classList.contains('open')) {
        _closePreview();
      }
    });

    // Click outside closes
    document.addEventListener('click', function (e) {
      if (preview && preview.classList.contains('open') && !e.target.closest('#pill-cart-wrap')) {
        _closePreview();
      }
    });

    // Mini-cart quantity + remove (delegated)
    document.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-mc-qty]');
      if (qtyBtn) {
        _miniCartChange(qtyBtn.getAttribute('data-mc-key'), parseInt(qtyBtn.getAttribute('data-mc-qty'), 10));
        return;
      }
      var rmBtn = e.target.closest('[data-mc-rm]');
      if (rmBtn) _miniCartChange(rmBtn.getAttribute('data-mc-rm'), -9999);
    });

    // Hook into non-form add-to-cart buttons
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.btn-p[data-variant], .pc-add-cart[data-variant]');
      if (!btn || btn.closest('form')) return;
      var variantId = btn.getAttribute('data-variant');
      if (!variantId) return;
      e.preventDefault();
      btn.disabled = true;
      var imgEl = _findProductImage(btn);
      if (imgEl) _flyToCart(imgEl);
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
      .then(function (r) { if (!r.ok) throw new Error('err'); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        _syncAllCartUI(cart, true);
        btn.disabled = false;
      })
      .catch(function () { btn.disabled = false; });
    });
  }

  /* --------------------------------------------------------
     19. Sticky buy bar — shows when main button scrolls out
     -------------------------------------------------------- */
  function initStickyBuy() {
    var mainBtn = document.querySelector('.pp-btns .btn-cart');
    var bar = document.getElementById('pp-sticky-bar');
    if (!mainBtn || !bar) return;

    var mobBar = document.querySelector('.mob-bar-wrap');
    var observer = new IntersectionObserver(function(entries) {
      var show = !entries[0].isIntersecting;
      bar.classList.toggle('visible', show);
      bar.style.display = '';
      if (mobBar) mobBar.classList.toggle('mob-bar-buy-hidden', show);
    }, { threshold: 0 });
    observer.observe(mainBtn);

    // Add to cart from sticky bar
    bar.querySelector('.pp-sticky-btn').addEventListener('click', function() {
      var btn = this;
      var vid = btn.getAttribute('data-variant');
      btn.disabled = true; btn.textContent = '...';
      fetch('/cart/add.js', {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify({items:[{id:parseInt(vid,10),quantity:1}]})
      })
      .then(function(r){return r.ok ? fetch('/cart.js') : Promise.reject()})
      .then(function(r){return r.json()})
      .then(function(cart){
        if(typeof _syncAllCartUI==='function') _syncAllCartUI(cart,true);
        btn.textContent = '\u2713 Ajout\u00e9';
        setTimeout(function(){ btn.textContent = 'Ajouter au panier'; btn.disabled = false; }, 1500);
      })
      .catch(function(){ window.location.href = '/cart'; });
    });
  }

  /* --------------------------------------------------------
     20. Upsell — add checked upsell items with main cart add
     -------------------------------------------------------- */
  function initUpsellCart() {
    // Listen in capture phase so it fires alongside initCartAjax
    document.addEventListener('submit', function(e) {
      var form = e.target.closest('#pp-form');
      if (!form) return;

      var checks = $$('.pp-upsell-check:checked');
      if (!checks.length) return;

      // Gather upsell variant IDs
      var upsellItems = [];
      checks.forEach(function(cb) {
        var label = cb.closest('[data-upsell-variant]');
        if (label) {
          upsellItems.push({ id: parseInt(label.getAttribute('data-upsell-variant'), 10), quantity: 1 });
        }
      });

      if (!upsellItems.length) return;

      // Add upsells after a small delay to let the main add fire first
      setTimeout(function() {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: upsellItems })
        }).catch(function() {});
      }, 400);
    }, true);
  }

  /* --------------------------------------------------------
     21. Install option — add install product with main cart
     -------------------------------------------------------- */
  function initInstallOption() {
    document.addEventListener('submit', function(e) {
      var form = e.target.closest('#pp-form');
      if (!form) return;

      var check = document.querySelector('.pp-install-check:checked');
      if (!check) return;

      var vid = check.getAttribute('data-install-variant');
      if (!vid) return;

      // Add install product after main add
      setTimeout(function() {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
        }).catch(function() {});
      }, 500);
    }, true);
  }

  /* --------------------------------------------------------
     Unified scroll handler — single rAF-throttled listener
     -------------------------------------------------------- */
  function initUnifiedScroll() {
    var nav = $('#nav');
    var bar = $('#pill-bar');
    var hdr = $('#pill-hdr');
    var navScrolled = false;
    var pillDocked = false;
    var ticking = false;

    function onScroll() {
      var y = window.scrollY;

      /* Nav #nav .scrolled */
      if (nav) {
        var shouldAdd = y > 30;
        if (shouldAdd !== navScrolled) {
          navScrolled = shouldAdd;
          nav.classList.toggle('scrolled', navScrolled);
        }
      }

      /* Pill-bar docking (all pages) */
      if (bar) {
        if (y >= 10 && !pillDocked) {
          pillDocked = true;
          bar.classList.add('scrolled');
          if (hdr) hdr.classList.add('is-scrolled');
        } else if (y < 10 && pillDocked) {
          pillDocked = false;
          bar.classList.remove('scrolled');
          if (hdr) hdr.classList.remove('is-scrolled');
        }
      }

      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });
  }

  /* --------------------------------------------------------
     Header height CSS variable (--header-h)
     -------------------------------------------------------- */
  function initHeaderHeight() {
    var bar = $('#pill-bar');
    var hdr = $('#pill-hdr');
    if (!bar || !hdr) return;

    function update() {
      if (bar.classList.contains('scrolled')) return;
      var h = bar.offsetTop + bar.offsetHeight;
      document.documentElement.style.setProperty('--header-h', h + 'px');
    }

    /* Le ResizeObserver appelle update() une première fois après la mise en page :
       pas de lecture forcée au démarrage (la valeur CSS par défaut est déjà la bonne). */
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(update).observe(bar);
    } else {
      requestAnimationFrame(update);
    }
  }

  /* --------------------------------------------------------
     Glass card mouse tracking
     -------------------------------------------------------- */
  /* bilan A5 — met en pause les animations infinies hors écran */
  function initOffscreenPause() {
    if (typeof IntersectionObserver === 'undefined') return;
    var els = $$('.eco-orbit-wrap, .krz-aura, .badge');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('is-offscreen', !e.isIntersecting);
      });
    }, { rootMargin: '100px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGlassCards() {
    if (!matchMedia('(hover:hover)').matches) return;
    var raf = 0;
    document.addEventListener('pointermove', function (e) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var card = e.target.closest('.krz-glass');
        if (!card) return;
        var r = card.getBoundingClientRect();
        card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        card.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    }, { passive: true });
  }

  /* --------------------------------------------------------
     Card ATC buttons (product cards with show_atc)
     -------------------------------------------------------- */
  function initCardATC() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.pc-atc');
      if (!btn || btn.classList.contains('is-loading')) return;

      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var label = btn.querySelector('.pc-atc-label');

      btn.classList.add('is-loading');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('err');
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        if (label) label.textContent = 'Ajouté';

        if (typeof _syncAllCartUI === 'function') _syncAllCartUI(cart, true);

        setTimeout(function () {
          btn.classList.remove('is-success');
          btn.disabled = false;
          if (label) label.textContent = 'Ajouter';
        }, 1500);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        if (label) label.textContent = 'Indisponible';
        setTimeout(function () {
          btn.classList.remove('is-error');
          btn.disabled = false;
          if (label) label.textContent = 'Ajouter';
        }, 2000);
      });
    });
  }

  /* --------------------------------------------------------
     Boot
     -------------------------------------------------------- */
  /* Démarrage découpé : on rend la main au navigateur toutes les ~40 ms
     (pas de « tâche longue » qui bloque le fil principal au chargement) — ~8 ms sur ordinateur ≈ 32 ms sur un téléphone moyen. */
  function krzBoot() {
    var fns = [initHeaderHeight, initScrollReveal, initNavScroll, initCatbarDropdowns, initBottomSheet, initFaqAccordions, initProductTabs, initCartAjax, initBuyNow, initQuantityControls, initCatPanel, initPillScroll, initUnifiedScroll, initMegaMenu, initSearchPill, initDockEffect, initHeroFlip, initLicenceCards, initCartPage, initFlyCart, initStickyBuy, initUpsellCart, initInstallOption, initGlassCards, initOffscreenPause, initCardATC, initMobileSliderDots, initFooterAccordions];
    var i = 0;
    (function step() {
      var t0 = performance.now();
      while (i < fns.length) {
        try { fns[i++](); } catch (err) { if (window.console) console.error(err); }
        if (performance.now() - t0 > 8) { setTimeout(step, 0); return; }
      }
    })();
  }

  /* La feuille krz.css arrive sans bloquer l'affichage : on attend qu'elle soit appliquée
     avant de mesurer quoi que ce soit (sliders, hauteur du header…). */
  var krzCss = document.getElementById('krz-css');
  if (!krzCss || krzCss.media === 'all') {
    krzBoot();
  } else {
    var krzBooted = false;
    var krzGo = function () { if (krzBooted) return; krzBooted = true; krzBoot(); };
    krzCss.addEventListener('load', function () { requestAnimationFrame(krzGo); });
    setTimeout(krzGo, 3000);
  }

})();

function initFooterAccordions() {
  if (window.innerWidth > 767) return;
  document.querySelectorAll('.f-col-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var col = btn.closest('.f-col');
      var isOpen = col.getAttribute('data-open') === 'true';
      /* Close all */
      document.querySelectorAll('.f-col').forEach(function(c) {
        c.setAttribute('data-open', 'false');
        var b = c.querySelector('.f-col-toggle');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      /* Open clicked if it was closed */
      if (!isOpen) {
        col.setAttribute('data-open', 'true');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

function syncHomeTabSliders(section, initial) {
  var activeChip = section.querySelector('.chip.on');
  var activeTab = activeChip ? activeChip.dataset.tab : '0';
  section.querySelectorAll('.home-tab-panel').forEach(function (panel) {
    var isActive = panel.dataset.tab === activeTab;
    var wrap = panel.parentElement && panel.parentElement.classList.contains('m-slider-wrap') ? panel.parentElement : null;
    if (wrap) wrap.hidden = !isActive;
    if (isActive) {
      /* écriture différée : évite un recalcul de mise en page forcé */
      if (!initial) requestAnimationFrame(function () { panel.scrollLeft = 0; }); /* au démarrage le défilement est déjà à 0 : pas de mise en page forcée */
      var dots = wrap ? wrap.querySelectorAll('.m-dot') : [];
      dots.forEach(function (d, i) { d.classList.toggle('on', i === 0); });
    }
  });
}

function initMobileSliderDots() {
  /* .lf-grid becomes a slider below 1024px */
  if (window.innerWidth <= 1023) {
    document.querySelectorAll('.lf-grid').forEach(function(s) {
      _setupSlider(s);
      requestAnimationFrame(function() { s.scrollLeft = 0; });
    });
  }

  if (window.innerWidth > 767) return;
  var selectors = '.prod-grid:not(#grid):not(.prod-grid--list), .why-g, .ps-grid, .art-related-grid, .cat-tiles, .pp-reco-grid, .m-slider, .tr-grid';
  var sliders = document.querySelectorAll(selectors);
  sliders.forEach(function(slider) { _setupSlider(slider); });

  /* Home-selection tabs: sync wrappers on click */
  document.querySelectorAll('.home-selection .chip[data-tab]').forEach(function(chip) {
    chip.addEventListener('click', function() {
      var sec = chip.closest('.home-selection');
      if (sec) requestAnimationFrame(function() { syncHomeTabSliders(sec); });
    });
  });

  /* Initial sync */
  document.querySelectorAll('[id*="home-selection"]').forEach(function(sec) {
    syncHomeTabSliders(sec, true);
  });
}

function _setupSlider(slider) {
  var items = Array.from(slider.children).filter(function(c) { return c.nodeType === 1 && !c.classList.contains('m-arrow'); });
  if (items.length < 2) return;

  /* ── Wrapper ── */
  var wrap = slider.parentElement && slider.parentElement.classList.contains('m-slider-wrap') ? slider.parentElement : null;
  if (!wrap) {
    wrap = document.createElement('div');
    wrap.className = 'm-slider-wrap';
    slider.parentNode.insertBefore(wrap, slider);
    wrap.appendChild(slider);
  }

  /* ── Remove old nav ── */
  var existingNav = wrap.querySelector('.m-dots');
  if (existingNav) existingNav.remove();
  wrap.querySelectorAll('.m-arrow').forEach(function(el) { el.remove(); });

  /* ── Navigation row: ‹  • • • •  › ── */
  var nav = document.createElement('div');
  nav.className = 'm-dots';

  var prevArr = document.createElement('button');
  prevArr.className = 'm-arrow m-arrow--prev m-arrow--disabled';
  prevArr.setAttribute('aria-label', 'Carte précédente');
  prevArr.textContent = '\u2039';
  nav.appendChild(prevArr);

  for (var i = 0; i < items.length; i++) {
    var d = document.createElement('button');
    d.className = 'm-dot' + (i === 0 ? ' on' : '');
    d.setAttribute('aria-label', 'Carte ' + (i + 1));
    d.setAttribute('data-idx', i);
    nav.appendChild(d);
  }

  var nextArr = document.createElement('button');
  nextArr.className = 'm-arrow m-arrow--next';
  nextArr.setAttribute('aria-label', 'Carte suivante');
  nextArr.textContent = '\u203A';
  nav.appendChild(nextArr);

  wrap.appendChild(nav);

  /* Dot click → scroll to card */
  nav.addEventListener('click', function(e) {
    var dot = e.target.closest('.m-dot');
    if (!dot) return;
    var idx = parseInt(dot.getAttribute('data-idx'), 10);
    if (items[idx]) items[idx].scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'smooth' });
  });

  var currentIdx = 0;

  prevArr.addEventListener('click', function(e) {
    e.stopPropagation();
    if (currentIdx > 0) items[currentIdx - 1].scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'smooth' });
  });
  nextArr.addEventListener('click', function(e) {
    e.stopPropagation();
    if (currentIdx < items.length - 1) items[currentIdx + 1].scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'smooth' });
  });

  function updateArrows(idx) {
    prevArr.classList.toggle('m-arrow--disabled', idx <= 0);
    nextArr.classList.toggle('m-arrow--disabled', idx >= items.length - 1);
  }

  /* ── IntersectionObserver for active dot ── */
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var idx = items.indexOf(entry.target);
      if (idx === -1) return;
      var allDots = nav.querySelectorAll('.m-dot');
      if (entry.isIntersecting) {
        currentIdx = idx;
        allDots.forEach(function(dd, j) { dd.classList.toggle('on', j === idx); });
        updateArrows(idx);
      }
    });
  }, { root: slider, threshold: 0.6 });

  items.forEach(function(item) { observer.observe(item); });
}
